import { render } from "./AdvisorHome.vue?vue&type=template&id=3dd7d9d9"
import script from "./AdvisorHome.vue?vue&type=script&lang=js"
export * from "./AdvisorHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__